import Box from "@galaxy-io/dls/layout/Box";
import Tabs from "@galaxy-io/dls/navigation/Tabs";
import { Link } from "@/app/navigation";
export function WorkflowTabs({ view }: { view: "library" | "runs" | "schedules" | "deliveries" }) {
  return (
    <Box padding={[0, 12]}>
      <Tabs
        as={Link}
        ariaLabel="Workflow sections"
        value={view}
        items={[
          { id: "library", label: "Library", href: "/workflows" },
          { id: "runs", label: "Runs", href: "/workflows?view=history" },
          { id: "schedules", label: "Schedules", href: "/workflows?view=schedules" },
          { id: "deliveries", label: "Deliveries", href: "/workflows?view=history&kind=delivery" },
        ]}
      />
    </Box>
  );
}
